import React, {FC} from 'react';
import cn from 'classnames';

import {Stepper} from '@zoefin/design-system';

import {SECTIONS} from '../../constants';
import {useFhs} from '../../store/FhsContext/hooks';

import {computeActiveStep} from './utils';

import styles from './styles.module.scss';

const RightPanel: FC = () => {
  const {formData, stepName} = useFhs();
  const {fullName} = formData;
  const activeStep = computeActiveStep(stepName);
  const isStepperHidden = stepName === 'name';

  const stepperWrapClass = cn(styles.rightPanel__stepperWrap, {
    [styles.rightPanel__stepperWrap_modHidden]: isStepperHidden,
  });

  const steps = SECTIONS.map((section) => ({label: section.label}));

  return (
    <div className={styles.rightPanel}>
      <div className={styles.rightPanel__desktop}>
        <div className={styles.rightPanel__greetingBlock}>
          <p className={styles.rightPanel__hi}>Hi,</p>
          <p className={styles.rightPanel__name}>{fullName || '...'}</p>
        </div>
        <div className={stepperWrapClass} aria-hidden={isStepperHidden}>
          <Stepper steps={steps} activeStep={activeStep} />
        </div>
      </div>
      <div className={styles.rightPanel__mobile}>
        <div className={styles.rightPanel__greetingBlock}>
          <p className={styles.rightPanel__hi}>Hi,</p>
          <p className={styles.rightPanel__name}>{fullName || '...'}</p>
        </div>
        <div className={stepperWrapClass} aria-hidden={isStepperHidden}>
          <Stepper
            steps={steps}
            activeStep={activeStep}
            orientation="horizontal"
            showLabels={false}
            size="sm"
          />
        </div>
      </div>
    </div>
  );
};

export default RightPanel;
